import { channelDashboardInitialState } from '../store.telegram'

export const clrChannelDashboard = (state) => {
  Object.assign(state, channelDashboardInitialState)
}
